
//  custom jQuery start

jQuery( document ).ready(function(e) {

  $('.main-image-wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.thumbnail-image-wrapper'
  });
  $('.thumbnail-image-wrapper').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.main-image-wrapper',
//     dots: false,
    arrows:true,
    focusOnSelect: true,
     responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });
  
  
  
  $(".syn-number-items .icons li").click(function(){
    var index = $(this).data('index');
    change_block(index);
    
  })
  
  $(".syn-img-container button").click(function(){
    var index = $(this).data('index');
    change_block(index);
  })
  
  $(".syn-disable-button").click(function(){
  	$(".syn-number-items").removeClass("disabled").addClass("opened");
    $(".content-block").removeClass("opened").addClass("disabled");
    $(".syn-line-visual").removeClass('active');
  })
  
  $(".syn-left-button").click(function(){
    var target = $(".syn-line-visual.active").parent();
    var index = target.data('index');
    if (index > 0 ) {
      index --;
      change_block(index);
    }
  });
  
  $(".syn-right-button").click(function(){
    var target = $(".syn-line-visual.active").parent();
    var index = target.data('index');
    if (index < 2) {
      index ++;
      change_block(index);
    }
  });
  
  function change_block(index){
  	$(".syn-number-items").removeClass("opened").addClass("disabled");
    $(".content-block").removeClass("disabled").addClass("opened");
    
    var texts=['Golden Arowana® HDPC® Rigid Core Waterpoof Vinyl Tile Flooring is 100% waterproof and require no acclimation prior to installation. Simple to clean and damp mop friendly. Ideal for all living areas, especially those with a higher risk of spills or increased humidity; including kitchens, bathrooms, mudrooms, and basements.',
               'Painted "Grout" line eliminates the need for messy grout. Just snap and go with our easy click system installation.', 
               'Visually stunning design that looks like real stone tile.'];
    
    $(".syn-active-view-content p").text(texts[index]);
    
    $('.syn-line-visual').removeClass('active');
    $('.icon-nub'+(index+1)+' .syn-line-visual').addClass('active');
    
    var titles=['1 of 3', '2 of 3', '3 of 3'];
    $(".header-titles p").text(titles[index]);    
  }
  $('.product__thumb-item').on('click', function(){
    var color = $(this).data('color');
    $('select.color').val(color).change();
  })
});


/*=====================
	#Cart Checkbox
=====================*/

function agreed()
{
  if($('#arownana-check').is(":checked"))   
    console.log('checkified')
    $('.cart-grey-out').addClass('hidden');
}